import { render, staticRenderFns } from "./inventory-note.vue?vue&type=template&id=4aaaef72"
import script from "./inventory-note.vue?vue&type=script&lang=js"
export * from "./inventory-note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports